import { Spinner } from '@cint/wonderment';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/constants';
import useHasPermission from '@/hooks/useHasPermission';

interface ProtectedRouteProps {
  children: ReactNode;
  action: string | string[];
  resource: string;
  isAllCompaniesRequired?: boolean;
}

export const ProtectedRoute = ({
  children,
  action,
  resource,
  isAllCompaniesRequired = false,
}: ProtectedRouteProps) => {
  const { hasPermission, isLoading } = useHasPermission({
    action,
    resource,
    isAllCompaniesRequired,
  });

  if (isLoading) {
    return <Spinner />;
  }

  return hasPermission ? (
    <>{children}</>
  ) : (
    <Navigate to={ROUTES.unauthorized} replace />
  );
};
